//
// Edge
//

class Edge {
  constructor(weight) {
    this.weight = weight instanceof Array ? weight : [weight];

    this.parent = null;
    this.child = null;
  }

  setParent(parent) {
    this.parent = parent;

    this.parent.addEdge(this);

    return this;
  }

  setChild(child) {
    this.child = child;

    return this;
  }
}

export default Edge;
